export const SACRED_INTENT_STORAGE_KEY = 'sacred_intent';
export const MAIN_CHAIN_DURATION_KEY = 'main_timer_duration_preference';
export const AUX_CHAIN_DURATION_KEY = 'aux_timer_duration_preference';

export const MAIN_CHAIN_SESSION_KEY = 'main_chain_session';
export const AUX_CHAIN_SESSION_KEY = 'aux_chain_session';

export const AUTO_START_MAIN_KEY = 'auto_start_main_timer';

export const DEFAULT_TASK_CATEGORY = 'study';

export const TASK_CATEGORY_OPTIONS = [
  { value: 'study', label: 'Study' },
  { value: 'work', label: 'Work' },
  { value: 'reading', label: 'Reading' },
  { value: 'writing', label: 'Writing' },
  { value: 'coding', label: 'Coding' },
  { value: 'meditation', label: 'Meditation' },
  { value: 'exercise', label: 'Exercise' },
  { value: 'custom', label: 'Custom' }
];

// Authorized emails for Private Pages
export const ADMIN_EMAILS = [
  'douglasj216@outlook.com'
];
